import React from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/fp/omit';
import { connect } from 'react-redux';
import { options } from 'config/reactRedux';
import { Link as ReactRouterLink } from 'react-router-dom';
import { isAbsolute, isMailto } from 'utils/url';
import createGetEditionPath from 'selectors/createGetEditionPath';

const Link = (props) => {
  const {
    disabled,
    className,
    children,
    pathWithLanguageEdition,
  } = props;

  if (disabled) {
    return (
      <span className={className}>
        {children}
      </span>
    );
  }

  const childProps = omit(
    ['isFooterLink', 'pathWithLanguageEdition'],
    props,
  );

  return isAbsolute(pathWithLanguageEdition) || isMailto(pathWithLanguageEdition) ? // eslint-disable-line max-len
    // a11y should be handled by the passed down props.
    <a // eslint-disable-line jsx-a11y/anchor-has-content
      href={pathWithLanguageEdition}
      {...childProps}
    /> :
    <ReactRouterLink
      {...childProps}
      to={pathWithLanguageEdition}
    />;
};

Link.propTypes = {
  ...ReactRouterLink.propTypes,
  pathWithLanguageEdition: PropTypes.string.isRequired,
};

Link.defaultProps = {
  to: '',
};

const mapStateToProps = (state, { to, isFooterLink }) => ({
  pathWithLanguageEdition: isFooterLink ? to : createGetEditionPath(to)(state),
});

const withRedux = connect(
  mapStateToProps,
  {},
  undefined,
  options,
);

export default withRedux(Link);
